import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl } from "../contexts";
const ControlFieldset = (param)=>{
    let { children } = param;
    const { params: { label, description, skipFieldSet, className }, initializeNotifications } = useCustomControl();
    return skipFieldSet ? /*#__PURE__*/ _jsx("div", {
        className: className || "",
        children: children
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !!label && /*#__PURE__*/ _jsx("span", {
                className: "customize-control-title",
                children: label
            }),
            !!initializeNotifications && /*#__PURE__*/ _jsx("div", {
                className: "customize-control-notifications-container",
                style: {
                    display: "none"
                },
                ref: initializeNotifications
            }),
            !!description && /*#__PURE__*/ _jsx("span", {
                className: "description customize-control-description",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: `customize-control-content ${className || ""}`,
                children: children
            })
        ]
    });
};
export { ControlFieldset };
